import { fetchQiniuToken, fetchQiniuTokenWithoutAuth } from "@/api/qiniu";
import * as qiniu from "qiniu-js";
import CryptoUtil from "./crypto";
import { message } from "./message";
import { ResponseResult } from "@/api/common";
import { publicFileHost } from "@/config/app";

export const tokenData = {
  token: "",
  expiresTime: 0
};

export async function getToken(noAuth?: boolean) {
  let info = tokenData;
  let now = Date.now();
  let expire = info.expiresTime - 60 * 1000; // 超时提前一分钟，防止临界时的bug
  if (!info.token || now >= expire) {
    let res = null;
    if (noAuth) {
      const pass = Date.now() + "..ygz123456!!";
      res = await fetchQiniuTokenWithoutAuth(CryptoUtil.base64Encode(pass));
    } else {
      res = await fetchQiniuToken();
    }
    if (res.code === 0) {
      let data = res.data;
      tokenData.expiresTime = data.expiresTime;
      tokenData.token = data.token;
    }
  }
  return tokenData.token;
}
// 上传图片返回结果
export type UploadImageResult = {
  id: number;
  height: number;
  mimetype: string;
  path: string;
  size: number;
  width: number;
  name: string;
};
// 默认上传配置：50MB 分片，3 个并发
const defaultUploadConfig = {
  chunkSize: 50,
  concurrentRequestLimit: 3
};
/**
 * 上传文件
 * @param image 文件对象
 * @param token 上传token，服务器端生成
 * @param formInput 表单参数
 */
export const uploadFile = (
  file: File,
  dir = "image",
  key?: string,
  noAuth?: boolean
): Promise<ResponseResult<UploadImageResult>> => {
  return new Promise(async (resolve, reject) => {
    const token = await getToken(noAuth).catch(() => null);
    if (!token) {
      message("获取上传token失败", { type: "error" });
      reject("获取token失败");
      return;
    }
    let fileKey = key || CryptoUtil.getUuid() + "." + file.name.split(".").pop();
    fileKey = dir + "/" + fileKey;
    // 上传开始,参数1file是上传的文件，后两个是上个接口拿到的返回值
    const observable = qiniu.upload(file, fileKey, token, undefined, defaultUploadConfig);
    const observer = {
      next() {},
      error(res) {
        message(res.message || "上传文件失败", { type: "error" });
        reject(res);
      },
      complete(res) {
        resolve(res);
      }
    };
    observable.subscribe(observer);
  });
};

/**
 * 上传文件(获取实时进度)
 * @param image 文件对象
 * @param token 上传token，服务器端生成
 * @param formInput 表单参数
 */
export const uploadFileonProgress = (
  file: File,
  dir = "image",
  key?: string,
  noAuth?: boolean,
  onProgress?: (percent: number) => void
): Promise<ResponseResult<UploadImageResult>> => {
  return new Promise(async (resolve, reject) => {
    const token = await getToken(noAuth).catch(() => null);
    if (!token) {
      message("获取上传token失败", { type: "error" });
      reject("获取token失败");
      return;
    }
    let fileKey = key || CryptoUtil.getUuid() + "." + file.name.split(".").pop();
    fileKey = dir + "/" + fileKey;
    // 上传开始,参数1file是上传的文件，后两个是上个接口拿到的返回值
    const observable = qiniu.upload(file, fileKey, token, undefined, defaultUploadConfig);
    const observer = {
      next(res) {
        // 实时监听上传进度
        if (onProgress && res.total && res.total.percent) {
          onProgress(res.total.percent);
        }
      },
      error(res) {
        message(res.message || "上传文件失败", { type: "error" });
        reject(res);
      },
      complete(res) {
        resolve(res);
      }
    };
    observable.subscribe(observer);
  });
};

export function getQiniuFile(path: string) {
  return publicFileHost + "/" + path;
}
